import React from 'react'

const Manual_cloudbeds_cargo_habitacion = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">Cloudbeds - Cargo a la Habitación desde InvuPOS</h2>
        <p className="text-lg text-gray-700 mb-6">
          Cómo cargar consumos a la habitación del huésped desde InvuPOS integrado con Cloudbeds para operaciones más ágiles.
        </p>
        <iframe
          src="https://scribehow.com/embed/Cloudbeds__Cargo_a_la_Habitacion_desde_InvuPOS__wiUQrwrSRYWCSLRZXA1dng?as=scrollable"
          className="scribe-iframe-general-201"
          width="100%"
          height="5200"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_cloudbeds_cargo_habitacion
